// src/api/selectionApi.js
import {$host} from "./index"; // Импортируем экземпляры axios из главного index.js

export const sendSelectionMail = async (formData) => {
    try {
        const {data} = await $host.post('api/selection', formData) // Используем $host, т.к. отправка письма часто не требует аутентификации
        return data
    } catch (e) {
        alert(e.response?.data?.message); // Добавлена обработка ошибки
    }
}